import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/lib/translations";

const I18nContext = createContext(null);

function detectLang() {
  const saved = localStorage.getItem("adnexa_lang");
  if (saved === "en" || saved === "id") return saved;
  const nav = (navigator.language || navigator.userLanguage || "en").toLowerCase();
  return nav.startsWith("id") ? "id" : "en";
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    localStorage.setItem("adnexa_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => translations[lang]?.[key] ?? translations.en[key] ?? key, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
